import illustrationPath from '../../assets/imgs/sign-in.svg';
import classes from './login.module.scss';
import { ILoginForm } from '../../Hooks/login.hook';
import { useLogin } from '../../Hooks';

import { Button, Checkbox, Form, Input, Row, Typography } from 'antd';
import { Wrapper } from '../../components/shared/wrapper.component';
import { RiLockFill, RiUserFill } from 'react-icons/ri';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

const LoginPage = () => {
  const login = useLogin();

  return (
    <Wrapper illustration={{ path: illustrationPath, name: 'login' }}>
      <div className={classes.loginContainer}>
        <div className={classes.textContainer}>
          <h1 className={classes.title}>Welcome Back</h1>
          <p className={classes.text}>Please enter your details.</p>
        </div>
        <Form<ILoginForm>
          className={classes.loginForm}
          initialValues={{ rememberMe: true }}
          onFinish={login.loginHandler}
          disabled={login.loading}
          validateTrigger="onBlur"
        >
          <Form.Item
            className={classes.formItem}
            name="username"
            rules={[
              { required: true, message: 'Please input your Email!' },
              { type: 'email', message: 'Please enter a valid Email address.' }
            ]}
          >
            <Input
              className={classes.inputField}
              prefix={<RiUserFill color="grey" />}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            className={classes.formItem}
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input
              className={classes.inputField}
              prefix={<RiLockFill color="grey" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item className={classes.formItem}>
            <Row justify="space-between">
              <Form.Item
                className={classes.formItem}
                name="rememberMe"
                valuePropName="checked"
                noStyle
              >
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              <Typography.Link className="login-form-forgot" href="/forgot-password">
                Forgot your password?
              </Typography.Link>
            </Row>
          </Form.Item>
          <Form.Item className={classes.formItem}>
            <Button
              type="primary"
              htmlType="submit"
              className={classes.loginBtn}
              loading={login.loading}
            >
              Log in
            </Button>
            <p className={classes.signUpText}>
              <span>
                Don't have an account?&nbsp;
                <Typography.Link href={`/register?dest=${login.dest}`}>Sign up</Typography.Link>
              </span>
            </p>
          </Form.Item>
          <GoogleReCaptcha
            onVerify={login.captchaVerifyHandler}
            refreshReCaptcha={login.refreshReCaptcha}
          />
        </Form>
        {login?.email && <div className={classes.resendContainer}>Didn't get the email?
          <Button
            type='link'
            disabled={!!login.resendTimer || login.loading}
            onClick={() => !login.resendTimer && login?.email && login.resendEmailVerificationHandler(login.email)}
          >
            &nbsp;Request again&nbsp;
          </Button>
          {!!login.resendTimer && `in ${login.resendTimer}s`}
        </div>}
      </div>
    </Wrapper>
  );
};

export default LoginPage;
